<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <router-link :to="{ name: 'qris' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">QRIS Merchant</div>
            <div class="right">
                <router-link
                    :to="{ name: 'qris.register' }"
                    class="headerButton"
                >
                    <ion-icon name="add-circle-outline"></ion-icon>
                </router-link>
            </div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div class="mt-2">
                <div class="section">
                    <div class="mb-2">
                        <ul class="listview image-listview inset m-0">
                            <li v-for="item in qris_merchants" :key="item.id">
                                <router-link
                                    :to="{
                                        name: 'qris.list.detail',
                                        params: { id: item.id },
                                    }"
                                    class="item"
                                >
                                    <div class="in">
                                        <div>
                                            <div
                                                style="
                                                    margin-bottom: 5px;
                                                    font-weight: bold;
                                                "
                                            >
                                                {{ item.merchant_name }}
                                            </div>
                                            <footer>
                                                <div>
                                                    NMID :
                                                    {{
                                                        item.merchant_id
                                                            ? item.merchant_id
                                                            : '-'
                                                    }}
                                                </div>
                                                <div>
                                                    <b>{{
                                                        item.qris_providers.name
                                                    }}</b>
                                                </div>
                                                <div>
                                                    Diterbitkan oleh
                                                    <b
                                                        >{{
                                                            item.qris_providers
                                                                .provider_by
                                                        }}
                                                    </b>
                                                </div>
                                            </footer>
                                        </div>
                                        <div class="text-right">
                                            <div class="mb-1">
                                                <span
                                                    class="badge badge-grey-custom pr-2 pl-2"
                                                    v-if="
                                                        item.status == 'DRAFT'
                                                    "
                                                    >{{ item.status }}</span
                                                >
                                                <span
                                                    class="badge badge-primary-custom pr-2 pl-2"
                                                    v-else-if="
                                                        item.status == 'PROCESS'
                                                    "
                                                    >{{ item.status }}</span
                                                >
                                                <span
                                                    class="badge badge-success-custom pr-2 pl-2"
                                                    v-else-if="
                                                        item.status == 'ACTIVE'
                                                    "
                                                    >{{ item.status }}</span
                                                >
                                                <span
                                                    class="badge badge-danger-custom pr-2 pl-2"
                                                    v-else-if="
                                                        item.status == 'REJECT'
                                                    "
                                                    >{{ item.status }}</span
                                                >
                                                <span
                                                    v-else
                                                    class="badge badge-info-custom pr-2 pl-2"
                                                    >{{ item.status }}</span
                                                >
                                            </div>
                                            <div>
                                                <span
                                                    class="badge badge-info-custom pr-2 pl-2"
                                                    v-if="item.is_default"
                                                    >Default</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- dialog Clear Cache -->
        <Dialog
            ref="dialog_alert_coming"
            :loading="false"
            :title="'Informasi'"
            @confirm="showAlertComing('hide')"
            :icon="'warning'"
        >
            <span class="text-standar"
                >Fitur ini masih dalam pengembangan dan akan segera tersedia,
                saat fitur ini sudah tersedia akan kami informasikan.</span
            >
        </Dialog>
    </div>
</template>
<script>
    // import $axios from './../../api.js';
    import { mapActions, mapState } from 'vuex';
    export default {
        data() {
            return {
                loading: {
                    content: false,
                },
                affiliate_id: '',
                loadingApp: false,
                loadingActionSheet: false,
                loadingButton: false,
            };
        },
        created() {
            this.loadingApp = true;
            this.getQrisMerchant().then(() => {
                this.loadingApp = false;
            });
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            ...mapState('qrisMerchant', {
                qris_merchants: state => state.qris_merchants,
            }),
        },
        methods: {
            ...mapActions('qrisMerchant', ['getQrisMerchant']),
        },

        mounted() {},
    };
</script>
<style>
    .table-min th,
    .table-min td {
        padding: 0.5rem 0.75rem 0.5rem 0.75rem;
    }
</style>
